import { useState, type PropsWithChildren } from "react";
import { useSupabaseAuth } from "./useSupabaseAuth";
import { hasPinConfigured } from "./usePinLock";
import { LoginForm } from "./LoginForm";
import { PinScreen } from "./PinScreen";

export function AuthGate({ children }: PropsWithChildren) {
  const { session, loading } = useSupabaseAuth();
  const [unlocked, setUnlocked] = useState(false);

  if (loading) return null;

  if (!session) {
    return <LoginForm />;
  }

  if (!unlocked) {
    const setup = !hasPinConfigured();
    return (
      <>
        <div className="app-content locked pointer-events-none">{children}</div>
        <PinScreen
          mode={setup ? "setup" : "verify"}
          title="Acceso privado"
          subtitle="Tus datos y fotos, solo tuyos"
          onSuccess={() => setUnlocked(true)}
        />
      </>
    );
  }

  return <div className="app-content">{children}</div>;
}
